import React from 'react'
import { connect } from 'react-redux'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import PaymentMethodContainer from '../forms/PaymentMethodContainer'
import InputRowPaymentMethod from '../components/InputRowPaymentMethod'

class PaymentMethod extends React.Component {
    render () {
        return (
            <div className='payment-method module overflow-visible'>
                <Heading title='Update my payment method' />
                <ModuleWithLoader isLoaded>
                    <div className='row p-4'>
                        <div className='col-12 col-md-8 offset-md-2 text-center'>
                            <p>Credit card expired or you’ve changed bank? Need to change your payment details? Well this is the place to be. Simply update your preferred payment method below and you’re sorted. Your updated card or account details will be used to process all future payments.</p>
                        </div>
                        <div className='col-12 col-md-6 offset-md-3'>
                            <PaymentMethodContainer>
                                <InputRowPaymentMethod paymentVia={this.props.paymentVia} />
                            </PaymentMethodContainer>
                        </div>
                    </div>
                </ModuleWithLoader>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    paymentVia: state.auth.paymentVia
})

export default connect(mapStateToProps, {})(PaymentMethod)



// WEBPACK FOOTER //
// ./resources/js/modules/PaymentMethod.js